import { useQuery } from '@tanstack/vue-query'
import { useAuthDependencies } from './auth'
import { useAuthStore } from '@/stores/auth'

export const useFeatureFlagsQuery = () => {
  const authGetter = useAuthDependencies()
  const authStore = useAuthStore()
  const query = useQuery({
    queryKey: ['features', authStore.userId],
    queryFn: async ({ signal }) => {
      const { axios } = await authGetter()
      return axios({
        method: 'GET',
        url: '/api/v2/workforce_intelligence/features',
        signal
      }).then((data) => {
        authStore.features = data.data
        return data.data
      })
    },
    refetchInterval: 60 * 1000,
    refetchIntervalInBackground: true
  })
  return { query }
}
